import { Breadcrumbs, Button, Card, Chip, Divider, Grid, Paper, styled, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { theme } from '../../commons/theme';
import CustomButtonTab from '../../components/CustomButtonTab';
import { Lock, Padding, People, PermScanWifiSharp, Security } from '@mui/icons-material';
import { DetalleModulosPermisos } from '../../components/cliente/DetalleModulosPermisos';
import { useDispatch, useSelector } from 'react-redux';
import { formatDateToYmd } from '../../commons/utils';
import { storeGetDetailCustomer } from '../../store/customer';
import { SnackAlert } from '../../components/SnackAlert';

export const DetailCustomer = () => {


    const dispatch = useDispatch();

    const navigate = useNavigate();

    // REDUX 
    const { customer }:any  = useSelector( (state:any) => state.customer );

    const [value, setValue] = React.useState(0);
    const [customerData, setCustomerData] = useState({});
    const [alert_snack, setAlertSnack] = React.useState(false);

    const [message_alert_snack, setMessageAlertSnack] = React.useState('');
    const [type_alert_snack, setTypeAlertSnack] = React.useState('success');




    useEffect(() => {
      setCustomerData(customer);
    }, [customer]);
    


    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        ...theme.applyStyles('dark', {
            backgroundColor: '#1A2027',
        }),
    }));



    interface TabPanelProps {
      children?: React.ReactNode;
      index: number;
      value: number;
    }
    
    function CustomTabPanel(props: TabPanelProps) {
      
      const { children, value, index, ...other } = props;
    
      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
      );
    }

    function a11yProps(index: number) {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };


    const editarCustomer = async(customerId: string) => {
     
          
        const customer = await dispatch( storeGetDetailCustomer(customerId) );
    
        if ( !customer.ok )  {
          
          setAlertSnack(true);
    
          await setMessageAlertSnack(customer.message);
    
          setTypeAlertSnack('error')
    
          return false;
        }
    
    
        navigate("/manager/clientes/editar-cliente");
    
    
    }

    

  return (
    <>

        <SnackAlert open={alert_snack} onclick={setAlertSnack} text={message_alert_snack} severity={type_alert_snack}/>


        <div style={{ widows: '100%' }}>
        <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Detalle Cliente</Typography>
        <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
            <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Manager</Typography>
            <Link color="inherit" to="/manager/clientes">
              Listar Clientes
            </Link>
            <Typography color="textPrimary">Detalle Cliente</Typography>
        </Breadcrumbs>

        <Divider sx={{ marginBottom: 3 }}/>


        
            <Grid container spacing={2} sx={{ marginTop: 7 }}>
                <Grid item xs={4}>

                <Card
                  sx={{
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                  }}
                >
                    <Typography variant='h6' sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.14rem', marginTop: 4, textTransform: 'capitalize' }}> {customer.name} </Typography>

                    <div style={{ width: '100%', textAlign: 'center', marginTop: 12 }}>
                      <Chip size='medium' label={'Activo'} sx={{ textAlign: 'center', color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} />
                    </div>

                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '1.14rem', marginTop: 4 }}>Detalles</Typography>
                    <Divider />

                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 4 }}>Responsable: <span style={{ fontWeight: 400 }}> {customer.person_in_charge}</span> </Typography>
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 1 }}>Email: <span style={{ fontWeight: 400 }}> {customer.email}</span> </Typography>
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 1 }}>Contacto responsable: <span style={{ fontWeight: 400 }}> {customer.contact}</span> </Typography>
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 1 }}>Pais: <span style={{ fontWeight: 400 }}> {customer.pais.label}</span> </Typography>
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 1 }}>Departamento: <span style={{ fontWeight: 400 }}> {customer.departamento.label}</span> </Typography>
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 1 }}>Municipio: <span style={{ fontWeight: 400 }}> {customer.municipio.label}</span> </Typography>
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 1 }}>Direccion: <span style={{ fontWeight: 400 }}> {customer.address}</span> </Typography>
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 1 }}>Fecha registro: <span style={{ fontWeight: 400 }}> {formatDateToYmd(customer.start_date)}</span> </Typography>


                    <Divider />
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '1rem', marginTop: 4 }}>Segundo responsable</Typography>
                    <Divider />
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 4 }}>Responsable: <span style={{ fontWeight: 400 }}>{customer.second_person_in_charge}</span> </Typography>
                    <Typography variant='h6' sx={{  fontWeight: 'bold', fontSize: '0.9rem', marginTop: 1 }}>Contacto responsable: <span style={{ fontWeight: 400 }}>{customer.second_customer_contact}</span> </Typography>


                    {
                        customer.status == 1 && <div style={{ width: '100%', textAlign: 'center'}}>
                        <Button onClick={ () => editarCustomer( customer.id ) } size='small' sx={{ marginTop: 3 }} variant="contained">Editar</Button>
                      </div>
                    }


                </Card>

                </Grid>
                <Grid item xs={8}>


                <Box sx={{ width: '100%' }}>
                  {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}> */}
                  <Box>
                    <Tabs TabIndicatorProps={{
                            style: { display: 'none' }, // También puedes usar esta propiedad directamente
                          }} 
                          selectionFollowsFocus={true} value={value} onChange={handleChange} aria-label="tabs detalle clientes">
                      <CustomButtonTab icon={ <Security />} iconPosition="start" label="Modulos y Permisos Cliente" {...a11yProps(0)} />
                    </Tabs> 
                  </Box>
                </Box>

                <Card
                  sx={{
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                    marginTop: 3
                  }}
                  >
                    
                    
                  <CustomTabPanel value={value} index={0}>
                      <DetalleModulosPermisos />
                  </CustomTabPanel>

                  </Card>
                </Grid>
            </Grid>


        
            

        </div>

    </>
  )
}
